import { SUPPORT_FEATURE } from "api/ApiPath";
import client from "api/client";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IApiDocumentRepository } from "features/apiDocumentFeature/domain/repositories/IApiDocumentRepository";
import { injectable } from "tsyringe";
import { ApiDocumentRequestModel } from "./model/ApiDocumentRequestModel";
import { ApiDocumentResponseModel } from "./model/ApiDocumentResponseModel";

@injectable()
export class ApiDocumentImpl implements IApiDocumentRepository {
  async getDocuments(
    params: ApiDocumentRequestModel
  ): Promise<ListBaseApiResponseModel<ApiDocumentResponseModel>> {
    return await client.get(SUPPORT_FEATURE.API_DOCUMENT, params);
  }
}
